import { Accordion } from "@/components/ui/accordion";
import React from "react";
import { useLocale, useTranslations } from "../../../helpers/translations";
import { generateLocalizedPath } from "../helpers/links";
import { RAILS_ROUTES } from "../helpers/routes";
import { MobileNavSubSection } from "../shared/MobileNavSubSection";
import { NavSubMenuSection } from "../shared/NavSubMenuSection";

type CompanySubMenuProps = {
  compact?: boolean;
  wrapperComponent: React.ComponentType<{
    title: string;
    children: React.ReactNode;
  }>;
};

export const CompanySubMenu = ({
  wrapperComponent,
  compact,
}: CompanySubMenuProps) => {
  const t = useTranslations("nav.community");
  const locale = useLocale();
  const WrapperComponent = wrapperComponent;

  if (!compact) {
    return (
      <WrapperComponent title={t("title")}>
        <NavSubMenuSection
          heading={t("vention.header")}
          items={[
            {
              title: t("vention.links.mission.title"),
              href: generateLocalizedPath(RAILS_ROUTES.ABOUT, locale),
            },
            {
              title: t("vention.links.careers.title"),
              href: generateLocalizedPath(RAILS_ROUTES.CAREERS, locale),
            },
            {
              title: t("vention.links.press.title"),
              href: generateLocalizedPath(RAILS_ROUTES.PRESS, locale),
            },
          ]}
        />
        <NavSubMenuSection
          heading={t("meet_with_us.header")}
          items={[
            {
              title: t("meet_with_us.links.events.title"),
              href: generateLocalizedPath(RAILS_ROUTES.EVENTS, locale),
            },
            {
              title: t("meet_with_us.links.contact_us.title"),
              href: generateLocalizedPath(RAILS_ROUTES.CONTACT, locale),
            },
          ]}
        />
      </WrapperComponent>
    );
  }

  return (
    <WrapperComponent title={t("title")}>
      <Accordion type="multiple" className="w-full border-none">
        <MobileNavSubSection
          title={t("vention.header")}
          items={[
            {
              title: t("vention.links.mission.title"),
              href: generateLocalizedPath(RAILS_ROUTES.ABOUT, locale),
            },
            {
              title: t("vention.links.careers.title"),
              href: generateLocalizedPath(RAILS_ROUTES.CAREERS, locale),
            },
            {
              title: t("vention.links.press.title"),
              href: generateLocalizedPath(RAILS_ROUTES.PRESS, locale),
            },
          ]}
        />
        <MobileNavSubSection
          title={t("meet_with_us.header")}
          items={[
            {
              title: t("meet_with_us.links.events.title"),
              href: generateLocalizedPath(RAILS_ROUTES.EVENTS, locale),
            },
            {
              title: t("meet_with_us.links.contact_us.title"),
              href: generateLocalizedPath(RAILS_ROUTES.CONTACT, locale),
            },
          ]}
        />
      </Accordion>
    </WrapperComponent>
  );
};
